module.exports = __webpack_public_path__ + "static/media/heavy_pound42.d39b8690.jpg";